import { call, put } from "redux-saga/effects";
import Axios from "../../utils/axios";
import { fetchAuthorizedEventDone } from "../../state/user/actions";
import { VERIFY_ACCOUNT_AUTHORIZED_EVENT } from "../../state/user/constants";
import { showErrorSnackbar } from "../../utils/util";
import { SOMETHING_WENT_WRONG_MESSAGE } from "../../constants";

function* fetchAuthorizedEvent({ accountId, eventId }) {
  try {
    const url = VERIFY_ACCOUNT_AUTHORIZED_EVENT.replace(
      ":accountId",
      accountId
    ).replace(":eventId", eventId);
    const result = yield call(Axios.core.get, url);
    yield put(
      fetchAuthorizedEventDone({
        authorized: result.data.authorized,
        accountId,
        eventId
      })
    );
  } catch (e) {
    showErrorSnackbar(SOMETHING_WENT_WRONG_MESSAGE, {
      removeOnHover: false
    });
  }
}

export default fetchAuthorizedEvent;
